import { useNavigate } from 'react-router'

import { useActivationContext } from '../../providers/activation-provider'
import BasicDialog from '../m3/basic-dialog'

const ExitActivationModal = ({
  showExitActivationDialog,
  setShowExitActivationDialog,
}: {
  showExitActivationDialog: boolean
  setShowExitActivationDialog: (value: boolean) => void
}) => {
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()
  return (
    <BasicDialog
      open={showExitActivationDialog}
      title="Exit activation?"
      textContent="You will lose all progress if you exit."
      onClose={() => setShowExitActivationDialog(false)}
      closeLabel="Back to activation"
      onConfirm={() => {
        setShowExitActivationDialog(false)
        navigate(`/device-roster/${activationLocationState.folderId}`, { state: activationLocationState })
      }}
      confirmLabel="Exit"
      showCloseIcon
    />
  )
}

export default ExitActivationModal
